// Only the deployed app reports to Sentry. The DSN is public and ships in every
// build, so without this gate local dev servers (localhost, LAN IPs, 0.0.0.0)
// and copies of the bundle on other sites sent events into the shared project,
// where they read as prod-looking issues and reopened resolved ones.
const REPORTING_DOMAIN = "factory.app";

export const isSentryReportingHost = (hostname) => {
  if (!hostname) {
    return false;
  }
  const host = hostname.toLowerCase();
  return host === REPORTING_DOMAIN || host.endsWith(`.${REPORTING_DOMAIN}`);
};
